import script from "./PainelRastreio.vue?vue&type=script&setup=true&lang=js"
export * from "./PainelRastreio.vue?vue&type=script&setup=true&lang=js"

import "./PainelRastreio.vue?vue&type=style&index=0&id=9843d3de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9843d3de"]])

export default __exports__